import React, { useEffect, useState } from "react";
import { Container, Button, Row, Col, Carousel, Modal } from 'react-bootstrap';
import Images from "../images";
import { useNavigate } from "react-router-dom";


function Playgalfimodal(props) {
    console.log("propsprops", props)

    const [detmodal, setDetmodal] = useState(true)
    const [data, setdata] = useState(null)
    const navigate = useNavigate();
    useEffect(() => {
        setdata(props.data)
    }, [props.data]);

    const dateFormater = (createdAt) => {
        const date = new Date(createdAt);
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        const formattedDate = date.toLocaleDateString('en-US', options);
        console.log(formattedDate);
        return formattedDate

    }
    return (

        <>
            <div className="">
                <Modal
                    className="detmodal"
                    // onHide={props.onDismiss}
                    show={detmodal}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered>
                    <Modal.Header closeButton onClick={props.onDismiss}></Modal.Header>
                    <Modal.Body className="pb-4 px-3 px-sm-5">
                        <h2 className="text-white fw-600 galfi_text text-center">GalFi Is Launching Soon</h2>
                        <p className="text-white text-center mt-4">
                            {/* {data?.description}  */}
                            A tokenised sci-fi strategy game and galactic-scale economic simulation.
                            Development in progress • Launching Q3 2026
                        </p>
                        <p className="text-white text-center mt-2">
                            The game will feature large-scale exploration, mining, base building,
                            trading, and combat — powered by a fully player-driven economy where
                            resources, ships, and structures are created by players.
                        </p>
                        <p className="text-white text-center mt-2">
                            Early access, updates, testing opportunities, and rewards are shared
                            first with the community.

                        </p>
                        <div className="text-white text-center mt-4">
                            <p>
                                <a href="https://discord.com/invite/7HDCQssqv9"
                                    target="_blank"
                                    className="socialTextLink"
                                >
                                    <button className="viewmore">Join the GalFi Discord</button>
                                </a>
                            </p>
                            <p>
                                <a
                                    href="https://x.com/GalFiofficial"
                                    target="_blank"
                                    className="socialTextLink"
                                >
                                    <button className="viewmore">Follow GalFi on X</button>

                                </a>
                            </p>
                        </div>

                        {/* <div className="d-flex align-items-center gap-1 justify-content-end">
                            <p className="mb-0 text-white">
                                <span className="ms-1">{dateFormater(data?.createdAt)}</span>
                                </p>
                        </div> */}
                    </Modal.Body>
                </Modal>


            </div>
        </>
    )
}

export default Playgalfimodal;
